import { FC } from 'react'

import { TextField } from '@/components/ui/text-field'
import { Tooltip } from '@/components/ui/tooltip'

interface Props {
  value: string
  onChange: (value: string) => void
}

export const ChatFeedbackBlock: FC<Props> = ({ value, onChange }) => {
  return (
    <div className="flex flex-1">
      <Tooltip
        content="Please enter how you would've written that message..."
        side="top"
        contentClassName="w-full text-start"
        asChild
      >
        <div className="w-full">
          <TextField
            value={value}
            onChange={(event) => onChange(event.target.value)}
            className="p-4 w-full h-full"
            placeholder="Please enter here..."
          />
        </div>
      </Tooltip>
    </div>
  )
}
